import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconUsb: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconUsb"><Path d="M11 8V5H9V8H11Z" fill="currentColor"/><Path d="M15 5V8H13V5H15Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M19 2H5V9H3V22H21V9H19V2ZM17 9V4H7V9H17Z" fill="currentColor"/></CentralIconBase>;
});

export default IconUsb;
